import { useLocation, useNavigate, Link } from "react-router-dom";

// Fuller sitemap, wording aligned to the navbar. Section links behave like the
// navbar links: from any other page they route home and scroll to the section.
const navLinks = [
  { label: "About", id: "about" },
  { label: "Approach", to: "/approach" },
  { label: "Services", id: "services" },
  { label: "Work", id: "portfolio" },
  { label: "People", id: "team" },
  { label: "Careers", id: "careers" },
  { label: "Contact", id: "contact" },
];

const socialLinks = [
  { label: "Instagram", href: "https://www.instagram.com/groundwork.marketing/" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/groundworkmarketing" },
  { label: "Substack", href: "https://substack.com/@groundworkmarketing" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const handleNav = (e, id) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer
      data-testid="main-footer"
      className="bg-[#2A3439] text-[#F7F5F0] pt-24 pb-12 relative overflow-hidden"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 border-b border-[#F7F5F0]/15 pb-16">
          <div className="md:col-span-6">
            <span className="text-xs uppercase tracking-[0.25em] text-[#F2C14E]">
              GroundWork. Brand strategy &amp; growth for ambitious brands worldwide
            </span>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.25em] text-[#F7F5F0]/60 mb-5">
              Navigate
            </div>
            <ul className="space-y-3">
              {navLinks.map((l) =>
                l.to ? (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="link-underline text-[#F7F5F0]/85 hover:text-[#F7F5F0]"
                      data-testid={`footer-link-${l.label.toLowerCase()}`}
                    >
                      {l.label}
                    </Link>
                  </li>
                ) : (
                  <li key={l.label}>
                    <a
                      href={`/#${l.id}`}
                      onClick={(e) => handleNav(e, l.id)}
                      className="link-underline text-[#F7F5F0]/85 hover:text-[#F7F5F0]"
                      data-testid={`footer-link-${l.label.toLowerCase()}`}
                    >
                      {l.label}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.25em] text-[#F7F5F0]/60 mb-5">
              Elsewhere
            </div>
            <ul className="space-y-3">
              {socialLinks.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-underline text-[#F7F5F0]/85 hover:text-[#F7F5F0]"
                    data-testid={`footer-social-${l.label.toLowerCase()}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Huge brand mark */}
        <div className="py-16 select-none">
          <div className="font-display tracking-tighter leading-none text-[#F7F5F0]/95 text-[18vw] md:text-[15vw] font-light text-center md:text-left">
            <span className="italic">Ground</span>Work.
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#F7F5F0]/60">
          <div>© {year} GroundWork. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <a
              href="#"
              data-testid="footer-privacy"
              className="link-underline hover:text-[#F7F5F0]"
            >
              Privacy
            </a>
            <a
              href="#"
              data-testid="footer-terms"
              className="link-underline hover:text-[#F7F5F0]"
            >
              Terms
            </a>
            <a
              href="#"
              data-testid="footer-disclosures"
              className="link-underline hover:text-[#F7F5F0]"
            >
              Disclosures
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
